export default Vue => {
  Vue.component("v-feedback", () => import("./v-feedback.vue"));
};
